<template>
    <div id="container">
        <div class="bg-left-red"></div>
        <div class="container" style="height:100%; ">
            <div class="hintergrund" style="height:inherit;">
                <div class="red"></div>
                <div class="orange"></div>
                <div class="main" style="background:#fff; box-shadow: 1px 1px 5px 0px rgba(50, 50, 50, 0.75);">
                    <div class="header row-fluid">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="background-color: #86063f; margin-left:-4px;">
                            <p><img src="@/assets/images/koennecke-2.png" alt="Könnecke Reisen Logo" /></p>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 head_text">
                            <span style="color: #918f8f; font-size: 16.5px; line-height: 120%; padding-top: 35px; display:block;">Herzlich Willkommen bei</span>
                            <span style="color: #918f8f; font-size: 23px; line-height: 120%;">Könnecke Reisen!</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 head_text2">
                            <img src="@/assets/images/tel.png" class="contact-phone-icon hidden-sm-and-down" /> <span class="contact-text">Beratung &amp; Buchung</span>
                            <span class="contact-number">035383 20325</span>
                        </div>
                    </div>
                    <div class="shadow_main">
                        <div class="showcase row-fluid  hidden-phone">
                            <div
                                class="image_slide col-lg-8 col-md-8 col-sm-8 col-xs-12"
                                style='background-position: center center; background-image: url("./images/koennecke.jpg"); background-repeat: no-repeat; background-size: cover; top: 0px; left: 0px; display: block;'
                            ></div>
                            <div class="search col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <div class="search_label">Urlaubsfinder</div>
                                <div class="Standard_100" style="height:auto;">
                                    <div class="KoenneckeSearch">
                                        <div class="row-fluid">
                                            <div class="KoenneckeSearchInput" style=""><el-input v-model="SearchStore.search" placeholder="Stichwort:"></el-input></div>
                                            <div class="KoenneckeSearchInput" style="">
                                                <el-select v-model="SearchStore.country" placeholder="Alle Länder" style="width: 100%;margin: 0px;">
                                                    <el-option label="Alle Länder" :value="null"> </el-option>
                                                    <el-option v-for="(country, a) in JourneyCountryStore" :key="a" :label="country.name" :value="country.id_loc_country"> </el-option>
                                                </el-select>
                                            </div>
                                            <div class="KoenneckeSearchInput" style="">
                                                <el-select v-model="SearchStore.category" placeholder="Alle Kategorien" style="width: 100%;margin: 0px;">
                                                    <el-option label="Alle Kategorien" :value="null"> </el-option>
                                                    <el-option v-for="(cat, d) in JourneyCategoryStore" :key="d" :label="cat.name" :value="cat.id_jrn_category"> </el-option>
                                                </el-select>
                                            </div>
                                            <div class="KoenneckeSearchInput">
                                                <el-date-picker
                                                    v-model="SearchStore.dateRange"
                                                    style="width:calc(100% - 10px);margin: 5px;"
                                                    placeholder="TT.MM.JJJJ"
                                                    format="dd.MM.yyyy"
                                                    type="daterange"
                                                >
                                                </el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="KoenneckeSearchInput" @click="searchJourneys"><input type="submit" value="SUCHEN »" class="hammerButton" /></div>
                                </div>
                            </div>
                        </div>
                        <div class="menu" style="height:35px; padding-top:5px;">
                            <div class="navbar navbar-light navbar-fixed">
                                <a class="btn btn-navbar" data-toggle="collapse" data-target=".nav-collapse" style="margin-right:35px;margin-top:1px;cursor:pointer !important;" @click="openNav()">
                                    <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span>
                                </a>
                                    
                                    <ul class="nav ushiddenDesktopNav" v-if="MenuStore.length > 0">
                                        <li class="dropdown" style="cursor:pointer;" v-for="(mainlevel, id_web_menu) in MenuStore[0].children" :key="id_web_menu">
                                            <a @click.stop="navigate(mainlevel.settings.link)" class="dropdown-toggle" data-toggle="dropdown"
                                                >{{ mainlevel.name }} <b class="caret" v-if="mainlevel.children.length > 0"></b
                                            ></a>
                                            <ul class="dropdown-menu" v-if="mainlevel.children.length > 0">
                                                <li v-for="(sublevel, b) in mainlevel.children" :key="b">
                                                    <a v-if="sublevel.settings.link.startsWith('https://')" target="new" :href="sublevel.settings.link">{{ sublevel.name }}</a>
                                                    <a v-else @click.stop="navigate(sublevel.settings.link)">{{ sublevel.name }}</a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>

                            </div>
                        </div>
                        <div class="maincontent">
                            <ContentContainer :search="Search"></ContentContainer>
                            <!-- <pre>{{JourneyStore.filter(i => i.id_jrn_category==45)}}</pre> -->
                            <div class="block" v-if="showslider" style="padding-top:40px;">                                
                                <swiper ref="mySwiper" :options="topSwiper"  style="height:351px;">
                                    <swiper-slide style="background-color: #86063f;" v-for="(Jdetail, a) in JourneyStore.filter(i => i.id_jrn_category==45)" :key="a" >
                                        <div class="DetailLitPic zoomDetail" id="Bigpic_0" style="position:relative;cursor: pointer; background-position: center center; background-repeat: no-repeat; background-size: cover;" v-bind:style="{ 'background-image': 'url(' + Jdetail.images[0].link + ')' }" >
                                            <a @click="navigateJourney(Jdetail)" :title="Jdetail.images[0].description"><div style="width:100%;height:199px;"></div></a>
                                            <div style="position:absolute;bottom:5px;right:5px;color:#fff;text-shadow: 0px 0px 2px #000000;">{{Jdetail.images[0].copyright}}</div>
                                        </div>
                                        <div style="color:#fff; padding:10px;height: 30px;margin-bottom: 10px;" class="line-clamp">{{Jdetail.title}}</div>                
                                        <div style="background-color:#E5E5E5;height:30px; padding:10px;border-bottom:1px solid #676767; color:#86063f; font-weight:bold;">
                                            {{settheDate(Jdetail.dates[0].date_from)}} - {{settheDate(Jdetail.dates[0].date_till)}}
                                            <span style="float:right;">{{Jdetail.dates[0].duration}} Tage</span>
                                        </div>                
                                        <div style="background-color:#E5E5E5;height:40px; padding:10px;font-weight:bold;font-size:20px;">{{Jdetail.dates[0].price/1000000}} ,- 
                                            <img @click="navigateJourney(Jdetail)" src="@/assets/images/btn_more1.png" style="height: 30px; margin-top: -5px; cursor: pointer; float:right;">
                                            
                                        </div>                
                                    </swiper-slide>                    
                                    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                                    <div class="swiper-button-prev" slot="button-prev"></div>
                                    <div class="swiper-button-next" slot="button-next"></div>
                                </swiper>
                            </div>
                        </div>
                    </div>
                    <div class="footer row-fluid" style="background-color: #f78a27;margin-left:-4px;">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="background-color: #86063f;margin-left:-5px;margin-top:-5px;margin-bottom:-5px;padding-right:25px">
                            <p>
                                Könnecke Reisen<br />Mittelstraße 18a<br />06895 Zahna-Elster OT Elster<br /><br />Tel.:&nbsp; 035383 20325<br />Fax:&nbsp; 035383 20947<br />Mail:
                                <a href="mailto:buchung@koennecke-reisen.de" style="color: white;">buchung@koennecke-reisen.de</a>
                            </p>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                            <ul class="joomla-nav">
                                <li class="item121" @click="navigate('/formular/Kontakt')" style="cursor:pointer;">Kontakt</li>
                                <li class="item121" @click="navigate('/article/Datenschutz')" style="cursor:pointer;">Datenschutz</li>
                            </ul>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-43 col-xs-12">
                            <ul class="joomla-nav">
                                <li class="item122" @click="navigate('/article/Impressum')" style="cursor:pointer;">Impressum</li>
                                <li class="item122" @click="navigate('/article/AGB')" style="cursor:pointer;">AGB</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

            <div id="mySidenav" class="sidenav">
                <div style="height:600px;overflow-y:auto;margin-top:10px;padding-top:20px;">
                    <a href="javascript:void(0)" class="closebtn" @click="closeNav()" style="margin-top:7px;">&times;</a>
                    <ul class="nav" v-if="MenuStore.length > 0" style="margin-top:-40px;">
                        <li style="cursor:pointer;" v-for="(mainlevel, id_web_menu) in MenuStore[0].children" :key="id_web_menu">
                            <a @click.stop="navigate(mainlevel.settings.link) , closeNav()" style="font-size:18px;padding-top:0px;padding-bottom:0px;line-height:140%;">{{ mainlevel.name }} </a>
                            <ul class="nav" v-if="mainlevel.children.length > 0" style="padding-left:20px;">
                                <li v-for="(sublevel, b) in mainlevel.children" :key="b" >                           
                                    <a @click.stop="navigate(sublevel.settings.link) , closeNav()"  style="font-size:13px;padding-top:0px;padding-bottom:0px;line-height:150%;color:rgba(255,255,255,0.7)">{{ sublevel.name }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <br><br>
                </div>
            </div>


    </div>
</template>
<script>
import TopNavi from "@/components/TopNavi.vue";
import ContentContainer from "@/components/ContentContainer.vue";
import CookieLaw from "vue-cookie-law";
import { mapState } from "vuex";
import moment from "moment";
export default {
    computed: {
        ...mapState(["JourneyCategoryStore", "CountryStore", "JourneyCountryStore", "MenuStore", "SearchStore", "JourneyStore"]),
        journeyCategories() {
            return this.JourneyCategoryStore;
        },
        journeyCountries() {
            return this.JourneyCountryStore;
        },
    },
    name: "container",
    data() {
        return {
           
            topSwiper: { 
                direction: 'horizontal', 
                slidesPerView: 3, 
                spaceBetween: 1, 
                loop: true, 
                speed:2000, 
                autoplay: {
                delay: 5000,
                },
                pagination: { el: '.swiper-pagination', clickable: true, type:'bullets' }, 
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                480: {
                slidesPerView: 1,               
                },              
                960: {
                slidesPerView: 2,               
                },              
                
            }            
            },

            showslider: true,
            search: { search: "", country: "", category: "", datefrom: "", datetill: "" },
            countries: [{ name: "Deutschland" }, { name: "Österreich" }],
            Search: { Hinfahrt: null, Rueckfahrt: null },
        };
    },
    components: { TopNavi, ContentContainer, CookieLaw },
    mounted() {
        this.$store.dispatch("listMenus");       
    },
    methods: {       
        openNav() {
            document.getElementById("mySidenav").style.width = "330px";
        },

        closeNav() {
            document.getElementById("mySidenav").style.width = "0";
        },        
        settheDate(date) {
            return moment(String(date))
                .locale("de")
                .format("DD.MM.YYYY");
        },
        searchJourney() {
            core.navigate({ path: `/journeyoverview/search/${this.search.search}` });
        },
        navigate(link, forceLoad = false) {
            if (link == this.oldLink) {
                return;
            }

            var checkSlider = link.split("/")[1];
            if (checkSlider == "reiseuebersicht" || checkSlider == "journeydetail") {
                this.showslider = false;
            } else {
                this.showslider = true;
            }

            this.oldLink = link;
            core.navigate({ path: link }, forceLoad);
        },
        searchJourneys() {
            this.navigate("/reiseuebersicht/search/" + JSON.stringify(this.SearchStore), true);
        },
        navigateJourney(jrn) {
            core.navigate({ path: "/journeydetail/" + jrn.id_jrn_journey });
        },
    },
};
</script>
<style>

  @media (max-width: 979px) {
      
      .ushiddenDesktopNav {
            display:none !important;
        }

  }
  @media (min-width: 600px) and (max-width: 959px) { }
  @media (min-width: 960px) and (max-width: 1263px) { }
  @media (min-width: 1264px) and (max-width: 1903px) { }
  @media (min-width: 1904px) { }

.ushiddenDesktopNav {
    display:inline-block;
}


.sidenav {
  height: 1500px;
  width: 0;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(134,6,63,0.95);
  overflow: hidden;
  transition: 0.5s;
  padding: 0px;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 20px;
  color: #fff;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: #fff;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}


.bg-left-red {
    background: #86063f;
    float: left;
    width: calc(50% - 140px);
    height: 100vh;
    position: fixed;
}
.bg-right-orange {
    background: #f78a27;
    width: calc(50% + 140px);
    height: 210px;
    position: absolute;
    right: 0px;
    bottom: 0px;
    float: right;
}
.contact-phone-icon {
    width: 40px !important;
    float: left;
    padding-top: 40px !important;
    padding-left: 40px !important;
}
.contact-number {
    color: #86063f;
    font-size: 28.66px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: -0.5px;
}
.contact-text {
    color: #86063f;
    font-size: 23.34px;
    line-height: normal;
    padding-top: 27px;
    display: block;
    letter-spacing: -0.5px;
}
@media screen and (max-width: 767px) {
    .contact-number {
        color: rgb(145, 143, 143);
        padding-bottom: 10px;
    }
    .contact-text {
        padding-top: 0px;
        color: rgb(145, 143, 143);
    }
}
.navbar-nav > li > a {
    color: #333333 !important;
    text-shadow: 0 0 0 !important;
}
.dropdown-menu .sub-menu {
    left: 100%;
    position: absolute;
    top: 0;
    visibility: hidden;
    margin-top: -1px;
}
.dropdown-menu li:hover .sub-menu {
    visibility: visible;
}
.dropdown:hover .dropdown-menu {
    display: block;
}
.nav-tabs .dropdown-menu,
.nav-pills .dropdown-menu,
.navbar .dropdown-menu {
    margin-top: 0;
}
.navbar .sub-menu:before {
    border-bottom: 7px solid transparent;
    border-left: none;
    border-right: 7px solid rgba(0, 0, 0, 0.2);
    border-top: 7px solid transparent;
    left: -7px;
    top: 10px;
}
.navbar .sub-menu:after {
    border-top: 6px solid transparent;
    border-left: none;
    border-right: 6px solid #fff;
    border-bottom: 6px solid transparent;
    left: 10px;
    top: 11px;
    left: -6px;
}
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:hover,
.navbar-default .navbar-nav > .active > a:focus {
    background: #f78a27 !important;
}
.menu li {
    line-height: 24px !important;
}
.el-input__inner {
    background-color: #fff !important;
}
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}
</style>
